import { render } from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=template&id=0c18ccea&scoped=true"
import script from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=script&lang=js"

import "./PRPMicroneedlingFacialContentPtBR.vue?vue&type=style&index=0&id=0c18ccea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c18ccea"]])

export default __exports__